document.addEventListener("DOMContentLoaded",function(){
    const bndle_swiper = new Swiper('.bundle-details-swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
      
        // If we need pagination
        // pagination: {
        //   el: '.swiper-pagination',
        // },
      
        // Navigation arrows
        navigation: {
          nextEl: '.bundle-details-button-next',
          prevEl: '.bundle-details-button-prev',
        },
        lazy: {
            loadPrevNext: true,
            loadOnTransitionStart: true
        },
        slidesPerView: 2,
        spaceBetween: 49,
        breakpoints: {
            320: {
                slidesPerView:1
            },
            767: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 2
            },
            1280: {
                slidesPerView: 2
            }
        },
        resizeObserver: true
      });
})